export function formatDate(iso: string) {
  return new Date(iso).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function formatNumber(n: number) {
  return new Intl.NumberFormat('pt-BR').format(n)
}

export function formatPercentage(value: number) {
  return new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 1 }).format(value)
}

export function formatCurrency(value: number) {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'USD' }).format(value)
}

export function formatDuration(startIso: string | null, endIso: string | null): string {
  if (!startIso || !endIso) return '—'
  const ms = new Date(endIso).getTime() - new Date(startIso).getTime()
  if (ms < 0) return '—'

  const totalSeconds = Math.floor(ms / 1000)
  const days = Math.floor(totalSeconds / 86400)
  const hours = Math.floor((totalSeconds % 86400) / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)

  if (days > 0) return `${days}d ${hours}h`
  if (hours > 0) return `${hours}h ${minutes}m`
  if (minutes > 0) return `${minutes}m`
  return `${totalSeconds}s`
}

export function highlightMatch(text: string, term: string): React.ReactNode {
  if (!term || term.length < 3) return text
  const truncated = text.length > 120 ? text.slice(0, 120) + '...' : text
  const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const regex = new RegExp(`(${escaped})`, 'gi')
  const parts = truncated.split(regex)
  return parts.map((part, i) =>
    i % 2 === 1
      ? <mark key={i} className="bg-yellow-200 rounded px-0.5">{part}</mark>
      : part
  )
}

export function statusBadge(status: string) {
  const config: Record<string, { cls: string; label: string }> = {
    ready: { cls: 'bg-green-100 text-green-700 dark:bg-green-500/15 dark:text-green-400', label: 'Online' },
    provisioning: { cls: 'bg-blue-100 text-blue-700 dark:bg-blue-500/15 dark:text-blue-400', label: 'Provisionando' },
    failed: { cls: 'bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-400', label: 'Falha' },
    pending: { cls: 'bg-yellow-100 text-yellow-700 dark:bg-yellow-500/15 dark:text-yellow-400', label: 'Pendente' },
  }
  const { cls, label } = config[status] || { cls: 'bg-accent text-foreground', label: status }

  return (
    <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${cls}`}>
      {label}
    </span>
  )
}
